import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-banner.component.html',
  styles: []
})
export class CookieBannerComponent implements OnInit {
  showBanner = signal<boolean>(false);

  ngOnInit() {
    const consent = localStorage.getItem('cookie-consent');
    if (consent !== 'true') {
      // Animate banner entry after a brief delay
      setTimeout(() => {
        this.showBanner.set(true);
      }, 1000);
    }
  }

  acceptCookies() {
    localStorage.setItem('cookie-consent', 'true');
    this.showBanner.set(false);
  }
}
